import React, { useState, useEffect, useContext } from "react";

import { HalfYearContext } from "../../../contexts/halfYearContext";
import { PopUpContext } from "../../../contexts/popUpContext";

import DataTable from "./CreditorList";
import MainTitle from "../../common/MainTitle";
import MainButton from "../../common/MainButton";
import TableMainSearch from "../../common/MainSearch";

import db from "../../../services/query";
import lbl from "../../../data/Labels.json";
import MainPrintLink from "../../common/MainPrint";
import { isFinanceReadOnly } from "../../../utils/financeAccess";

const Creditors = (props) => {
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");

  const { halfYear } = useContext(HalfYearContext);
  const { togglePopUp, popUp } = useContext(PopUpContext);
  const { did } = props.match.params;

  useEffect(async () => {
    const ac = new AbortController();

    requestData({ halfYear });

    return () => ac.abort();
  }, [halfYear, popUp]);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      let query = `expenses/debtType/${did}/creditors?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={data?.summary?.title} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          {!isFinanceReadOnly() && (
          <MainButton
            title={lbl.CreateCreditor}
            handleClick={() => togglePopUp({ form: "creditor-form" })}
            type={"add"}
          />
          )}
          <MainPrintLink path={`expenses/debtType/${did}/creditors/halfYear/${halfYear}`} />
        </div>
      </div>
      <div className="main-content-body">
        <DataTable data={data} query={query} />
      </div>
    </div>
  );
};

export default Creditors;
